import Vue from 'vue'
import {
  Container,
  Header,
  Aside,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Button,
  Cascader,
  Message,
  Notification,
  Loading,
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Steps,
  Step,
  Drawer,
  Row,
  Select,
  Option,
  Radio,
  Input,
  InputNumber,
  RadioGroup,
  Rate,
  Dialog,
  Pagination,
  Upload,
  CheckboxGroup,
  Checkbox,
  MessageBox,
  Popconfirm,
  Popover,
  DatePicker,
  Link,
  Image,
  Divider,
  Tree,
  Autocomplete,
  Tooltip,
  Alert
} from 'element-ui';
Dialog.props.lockScroll.default = false;
Vue.use(Button)
Vue.use(Alert)
Vue.use(Autocomplete)
Vue.use(Link)
Vue.use(Tree)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Steps)
Vue.use(Divider)
Vue.use(Step)
Vue.use(Popconfirm)
Vue.use(Popover)


Vue.use(Option)
Vue.use(Select)
Vue.use(Cascader)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(Rate)
Vue.use(RadioGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Drawer)
Vue.use(Row)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(Tooltip)

Vue.prototype.$ELEMENT = { 
  zIndex: 2000
};
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$loading = Loading.service;

// 图片懒加载，
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  error: require('../assets/image/icon/img_error.png'), //加载失败的默认图
  loading: require('../assets/image/icon/loading.png') //加载中的默认图
})



// WEBPACK FOOTER //
// ./src/utils/prototype.js